import { Component, ChangeDetectorRef } from '@angular/core'
import { AgFilterComponent } from 'ag-grid-angular'
import { LookupFilterComponent } from './lookup-filter/lookup-filter.component'
import { Option } from '../../app-select/option'

@Component({
  selector: 'app-high-priority-filter',
  templateUrl: './lookup-filter/lookup-filter.component.html',
  styleUrls: ['./lookup-filter/lookup-filter.component.scss'],
  standalone: false
})
export class HighPriorityFilterComponent
  extends LookupFilterComponent
  implements AgFilterComponent
{
  constructor(cdr: ChangeDetectorRef) {
    super(cdr)
    this.items = [new Option(true, '!', true), new Option(false, '{empty}', false)]
  }
}
